import React from 'react';
import { useRouter } from 'next/router';
import { menu, tosPage } from '@/constants/tos';
import Dropdown from '@/components/ui/common/Dropdown';
import { P } from '@/components/shadcn/typography';

interface Props {
  page?: string;
}

const Nav = ({ page }: Props) => {
  const router = useRouter();
  const placeholder = menu[(page as tosPage) || tosPage.mappingNetwork];

  return (
    <div className="mb-6 flex flex-col gap-6 pt-6">
      <P className="text-lg font-bold text-neutral-0">Terms of Service</P>
      <Dropdown
        className="w-full"
        variant="light"
        value={placeholder.target}
        onChange={value => router.push(value, undefined, { shallow: true })}
        options={Object.values(menu).map(item => ({
          label: item.title,
          value: item.target,
        }))}
      />
    </div>
  );
};

export default Nav;
